import { cn } from '../../lib/utils.js';

interface ErrorStateProps {
  message?: string;
  className?: string;
}

export function ErrorState({ message = 'Failed to load data.', className }: ErrorStateProps) {
  return <p className={cn('py-12 text-center text-sm text-destructive', className)}>{message}</p>;
}
